import React, { useEffect, useState } from "react";
import MyTable from "../components/MyTable";
import SearchInput from "../components/SearchInput";
import { jwtDecode } from "jwt-decode";
import PatientProfilePage from "./PatientProfilePage";
import { motion, AnimatePresence } from "framer-motion";
import { FaEdit, FaTimes } from "react-icons/fa";
import { IoCloseOutline } from "react-icons/io5";
import Loading from "../components/Loading";
import BillingForm from "./BillingForm";
import { useSidebar } from "../context/ClinicContext";
import { serviceGetListOfPatientsForClinicId } from "../services/api";
import EditPatientModal from "../components/EditPatientModal";
const PatientList = () => {
  const [patients, setPatients] = useState([]);
  const [filterInput, setFilterInput] = useState("");
  const [showBillingForm, setShowBillingForm] = useState(false);
  const [showEditPatientForm, setShowEditPatientForm] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [selectedPatientId, setSelectedPatientId] = useState(null); // Added state

  const {
    showEditModal,
    toggleEditModal,
  } = useSidebar();

  const token = localStorage.getItem("token");
  const decodedToken = jwtDecode(token);

  const handleCreateBill = (patientId) => {
    setSelectedPatientId(patientId);
    setShowBillingForm(true);
  };

  const handleCloseBillingForm = () => {
    setSelectedPatientId(null);
    setShowBillingForm(false);
  };

  const columns = [
    { Header: "ID", accessor: "patient_id" },
    { Header: "Name", accessor: "name" },
    { Header: "Age", accessor: "age" },
    { Header: "Contact", accessor: "primary_phone_number" },
    { Header: "Gender", accessor: "gender" },
    {
      Header: "Actions",
      Cell: ({ row }) => (
        <div className="flex space-x-2">
        <button
          className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-1 px-2 rounded-md text-sm"
          onClick={() => handleEditClick(row.original)}
        >
          Details
        </button>
        <button
          className="bg-green-500 hover:bg-green-600 text-white font-semibold py-1 px-2 rounded-md text-sm"
          onClick={() => handleOpenEditPatientForm(row.original)}
        >
          Edit
        </button>
      </div>
        
      ),
    },
  ];

  const handleModalClose = () => {
    setShowEditPatientForm(false);
    setSelectedPatient(null);
  };

  const handleFilterChange = (event) => {
    const value = event.target.value || "";
    setFilterInput(value);
  };

  const handleEditClick = (patient) => {
    setSelectedPatient(patient);
    toggleEditModal(); // Toggle the edit modal state
  };

  const handleOpenEditPatientForm = (patient) => {
    setSelectedPatient(patient);
    setShowEditPatientForm(true);
  };

  const handleCloseProfile = () => {
    setSelectedPatient(null);
    toggleEditModal(); // Toggle the edit modal state
  };

  const fetchData = async () => {
    const response = await serviceGetListOfPatientsForClinicId(decodedToken.clinic_ids[0]);
    if(response?.status){
      setPatients(response?.data?.patients);
    }
  };
  
  useEffect(() => {
    fetchData();
  }, []);

  const breadcrumbs = [
    { label: "Home", href: "#", class: "text-[#2E37A4]" },
    { label: "Patients List", class: "text-[#2E37A4]" },
  ];

  return (
    <>
      <div
        className={`page-container relative h-full flex flex-auto flex-col px-4 sm:px-6 py-4 sm:py-6 md:px-8 ${
          showBillingForm ? "blur-sm pointer-events-none" : ""
        }`}
      >
        {/* <motion.div
        initial={{ width: "100%" }}
        animate={{ width: selectedPatient ? "25%" : "100%" }}
        transition={{ duration: 0.5, ease: "easeInOut" }}
        className="bg-white shadow-md rounded-xl overflow-hidden"
      > */}

        {/* <Loading /> */}

        <div className="bg-white shadow-md rounded-xl overflow-hidden">
          <div className="px-5 py-3">
            <div>
              <div className="text-lg font-semibold text-gray-800">
                Patients List
              </div>
            </div>
            <div className="mt-4">
              <SearchInput
                filterInput={filterInput}
                handleFilterChange={handleFilterChange}
              />
            </div>
          </div>
          <div className="overflow-auto ">
            <MyTable
              columns={columns}
              data={patients}
              filterInput={filterInput}
              handleFilterChange={handleFilterChange}
            />
          </div>
        </div>
        {/* </motion.div> */}
        <AnimatePresence>
          {showEditModal && selectedPatient && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              className={`bg-white shadow-md rounded-none fixed right-0 top-0 h-full z-40 w-full lg:w-[calc(100%-322px)] xl:w-[calc(100%-322px)] 2xl:w-[calc(100%-30%)] ${
                showBillingForm ? "blur-sm pointer-events-none" : ""
              }`}
            >
              <button
                className=" text-gray-600 bg-transparent hover:bg-gray-100 hover:text-gray-800 px-0 w-10 h-10 inline-flex justify-center items-center rounded-full text-2xl m-1.5"
                onClick={handleCloseProfile}
              >
                <IoCloseOutline />
              </button>
              <PatientProfilePage
                patient={selectedPatient}
                handleCreateBill={handleCreateBill}
                handleCloseModal={handleCloseProfile}
              />
            </motion.div>
          )}
        </AnimatePresence>
        <AnimatePresence>
          {showEditPatientForm && selectedPatient && (
            <EditPatientModal
              patient={selectedPatient}
              isOpen={showEditPatientForm}
              onClose={handleModalClose}
              fetchData={fetchData}
            />
          )}
        </AnimatePresence>
      </div>
      {showBillingForm && (
        <BillingForm
          patientId={selectedPatientId}
          onClose={handleCloseBillingForm}
        />
      )}
    </>
  );
};

export default PatientList;
